import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-form-verification-condition-suspensive",
  templateUrl: "./form-verification-condition-suspensive.component.html",
  styleUrls: ["./form-verification-condition-suspensive.component.scss"],
})
export class FormVerificationConditionSuspensiveComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
